var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data && _vm.data.length)?_c('div',{staticClass:"suggestor",class:{ 'suggestor--loading': !_vm.data }},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"suggestor__line",on:{"click":function($event){return _vm.output(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }